import { useMemo } from 'react';
import Alooma from 'services/alooma';
import * as ALOOMA from 'consts/alooma';
import { getQueryParam } from 'functions/urlHelpers';
import { QUERY_PARAMS } from 'consts/queryParams';
import GlobalSearchEmptyState from '../GlobalSearchEmptyState/GlobalSearchEmptyState';

const GlobalSearchEmptyStateContainer = () => {
  const query = getQueryParam(QUERY_PARAMS.query);
  const emptyNonContextDataAttrs = useMemo(
    () => ({
      [ALOOMA.PARAMS.SEARCH_PHRASE]: query,
      [ALOOMA.PARAMS.ERROR_MESSAGE]: ALOOMA.ELEMENTS.NO_RESULTS_FOUND,
    }),
    [],
  );

  return (
    <Alooma.NonStandardDataContext.Provider value={emptyNonContextDataAttrs}>
      <GlobalSearchEmptyState />
    </Alooma.NonStandardDataContext.Provider>
  );
};

export default GlobalSearchEmptyStateContainer;
